<template>
  <main class="campaign-creator campaign-creator-wrapper flex flex-col flex-nowrap">
    <div class="editor-container flex flex-col w-full">
      <!-- necessary to prevent click-through onto the buttons, because the modals utilize `pointer-events: none;` in order to get around the fact that vue-simple-modal does not support disabling clicks outside the modal during long submissions: https://github.com/toannt181/simple-modal-vue/issues/10-->
      <div v-if="showVideoModal || showEditStashboardMediaModal" class="modal-backdrop2 z-10 absolute transparent top-0 left-0 bottom-0 right-0"></div>

      <edit-stashboard-media-modal v-if="showEditStashboardMediaModal"
                                   :show-modal.sync="showEditStashboardMediaModal"
                                   class="image-modal"
                                   :class="[
                                     {'bg-cover-contain': ownerStashboardMedia.length === 1},
                                     {'modal-click-outside-disabled': loadingStashboardMedia}
                                   ]"
                                   :stashboard-media="editStashboardImagesGrid"
      />
      <add-video-modal v-if="showVideoModal"
                       :show-modal.sync="showVideoModal"
                       :stashboard-media="editStashboardVideo"
                       class="video-modal"
                       :class="[
                         {'modal-click-outside-disabled': loadingStashboardMedia}
                       ]"
      />
      <section class="image-container min-h m-0 relative w-full flex items-center justify-center"
               v-if="!classicCampaignsEnabled">
        <div v-if="previewStashboardMedia.length === 0" class="flex justify-center items-center">
          <sb-loading-icon v-if="loadingStashboardMedia"/>
          <template v-else>
            <button class="rounded-blue w-28 mr-6 flex flex-col items-center"
                    @click="clickedAddImageBtn"
                    @disabled="loadingStashboardMedia"
                    data-cy="add-image-button">
              <fai class="fs-25 scale-x-1 mb-1" :icon="['fal', 'image']"/>
              add image
            </button>
            <button class="rounded-blue w-28 flex flex-col items-center"
                    v-if="stashboardMultipleEnabled"
                    @click="clickedAddVideoBtn"
                    @disabled="loadingStashboardMedia"
                    data-cy="add-video-button">
              <fai class="fs-25 mb-1" :icon="['fal', 'fa-circle-play']"/>
              add video
            </button>
          </template>
        </div>
        <div v-else class="grid grid-cols-4 w-full h-full">
          <div class="col-span-3 border-r-1 border-0 border-solid">
            <div class="flex justify-center items-center h-full" v-if="loadingStashboardMedia">
              <sb-loading-icon/>
            </div>
            <CarouselCampaign v-else
                              class="carousel"
                              :class="{'bg-cover-contain': ownerStashboardMedia.length === 1}"
                              ref="carousel-campaign"
                              @remove-slide="removeStashboardMedia"
                              :slides="previewStashboardMedia"/>
          </div>
          <div class="col-span-1 relative">
            <div class="flex absolute top-2 right-2">
              <div class="flex items-center text-lg text-lime-700" :class="[paginationClass]"/>
            </div>
            <div class="flex flex-col items-center justify-center h-full">
              <button class="rounded-blue py-2 px-4 flex flex-col items-center w-28"
                      @click="clickedAddImageBtn"
                      :disabled="loadingStashboardMedia"
                      data-cy="add-image-button">
                <fai class="fs-25 mb-1 scale-x-1" :icon="['fal', 'image']"/>
                add image
              </button>
              <button class="rounded-blue py-2 px-4 mt-5 flex flex-col items-center w-28"
                      @click="clickedAddVideoBtn"
                      v-if="stashboardMultipleEnabled"
                      :disabled="loadingStashboardMedia"
                      data-cy="add-video-button">
                <fai class="fs-25 mb-1" :icon="['fal', 'fa-circle-play']"/>
                add video
              </button>
            </div>
          </div>
        </div>
      </section>

    </div>
  </main>
</template>

<script>
import _ from 'lodash'

import {mapGetters} from "vuex";
import EditStashboardMediaModal from "./edit-stashboard-media-modal.vue";
import AddVideoModal from "./add-video-modal.vue";
import CarouselCampaign from "./carousel-campaign.vue"

let saveAds = []
export default {
  name: "stashboard-media-uploader",
  components: {
    EditStashboardMediaModal,
    AddVideoModal,
    CarouselCampaign
  },

  data() {
    return {
      showEditStashboardMediaModal: false,
      showVideoModal: false,
      loading: false
    };
  },
  methods: {
    clickedAddVideoBtn() {
      this.showVideoModal = true;
    },
    clickedAddImageBtn() {
      this.showEditStashboardMediaModal = true;
    },

    async removeStashboardMedia(stashboardMedia) {
      this.$store.dispatch('REMOVE_STASHBOARD_MEDIA', { stashboardMedia })
    }
  },

  computed: {
    paginationClass() {
      return `swiper-pagination-campaign-${this.stashboardCommunicationType}`
    },
    ...mapGetters([
      "maxImages",
      "loadingStashboardMedia",
      "stashboardCommunicationType",
      "ownerStashboardMedia",
      "prevStashboardMedia",
      "previewStashboardMedia",
      "previewStashboardImages",
      "editStashboardImagesGrid",
      "editStashboardVideo",
      "stashboardMultipleEnabled",

      "classicCampaignsEnabled"
    ]),
    ...mapGetters({
      ownerId: "stashboardOwnerId",
      ownerType: "stashboardOwnerType",
      owner: "stashboardOwner"
    })
  }
}
</script>

<style lang="scss" scoped>
.image-container {
  height: 358px;
  border-right: 1px solid #A6D4FC;
  border-left: 1px solid #A6D4FC;

  button {
    font-family: "AileronThin", sans-serif;
    font-size: 18px;
  }
}

:disabled {
  cursor: pointer;
  opacity: 0.5;
}

.bg-cover-contain {
  ::v-deep .img-container {
    background-size: contain;
  }
}

.image-modal ::v-deep,
.video-modal ::v-deep {
  > div {
    border-radius: 30px;
    width: 572px;

  }

  .upload-button{
    svg {
      font-size: 25px;
      transform: scaleX(-1);
    }
  }

  .block {
    button {
      border-radius: 16px;
      padding: 10px 30px !important;

      svg {
        font-size: 25px;
        transform: scaleX(-1);
      }
    }
  }

  .add-image-modal {
    width: 516px;

    > div {
      border-radius: 30px;

      > section {
        width: 490px;

        .sb-thumbnail {
          height: 70px;
          width: 70px;
        }
      }
    }
  }

  .add-image-container {
    width: 490px;

    > button {
      border-radius: 16px;
      padding: 10px 30px;

      svg {
        font-size: 25px;
        transform: scaleX(-1)
      }
    }
  }

  footer {
    > button {
      border-radius: 16px;
      text-transform: lowercase;
    }
  }
}

.carousel {
  ::v-deep .img-container {
    display: flex;
    align-items: center;

    .remove-action {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.video-modal ::v-deep {
  .add-image-container {
    height: 400px;
    width: auto;
  }

  > div main.error-banner.text-white.bg-red {
    display: none;
  }

  > div header main.error-banner.text-white.bg-red {
    display: block;
  }

  .block {
    button {
      padding: 10px 40px;
    }
  }

  .flex {
    p.pt-3 {
      font-size: 30px;
    }
  }
}

.fs-25 {
  font-size: 25px;
}

.scale-x-1 {
  transform: scaleX(-1);
}

.image-modal {
  ::v-deep .add-image-modal {
    min-height: 400px;
  }
}
</style>
